import React from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'
import { numberThousandSeparator } from '../../../utils/formatterUtil'

export default function ClusterChart({ schema, ...props }) {
  // const optionProject = {
  //   title: {
  //     text: schema.name,
  //     left: 'center',
  //     bottom: 5,
  //     textStyle: {
  //       color: '#575757',
  //     },
  //   },
  //   series: [
  //     {
  //       type: 'gauge',
  //       startAngle: 90,
  //       endAngle: -270,
  //       pointer: {
  //         show: false,
  //       },
  //       progress: {
  //         show: true,
  //         overlap: false,
  //         roundCap: true,
  //         clip: false,
  //         // itemStyle: {
  //         // borderWidth: 1,
  //         // borderColor: '#464646',
  //         // },
  //       },
  //       axisLine: {
  //         lineStyle: {
  //           width: 45,
  //         },
  //       },
  //       splitLine: {
  //         show: false,
  //         distance: 0,
  //         length: 10,
  //       },
  //       axisTick: {
  //         show: false,
  //       },
  //       axisLabel: {
  //         show: false,
  //         distance: 50,
  //       },
  //       data: [
  //         {
  //           value: schema.value,
  //           title: {
  //             offsetCenter: ['0%', '0%'],
  //           },
  //           detail: {
  //             valueAnimation: true,
  //             offsetCenter: ['0%', '0%'],
  //           },
  //         },
  //       ],
  //       title: {
  //         fontSize: 14,
  //       },
  //       detail: {
  //         fontSize: 20,
  //         formatter: '{value}%',
  //       },
  //       color: [schema.color],
  //     },
  //   ],
  // }

  // console.log('schema : ', JSON.stringify(schema))
  const optionProject = {
    color: schema.gaugeColor,
    title: {
      text: schema.name,
      left: 'center',
      bottom: 0,
      textStyle: {
        color: '#575757',
      },
    },
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        radius: '68%',
        pointer: {
          show: false,
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          // width: 20,
        },
        axisLine: {
          lineStyle: {
            width: 40,
          },
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
          distance: 50,
        },
        data: [
          {
            value: schema.approve.percent,
            name: schema.approve.label,
            title: {
              offsetCenter: ['0%', '-40%'],
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '-15%'],
            },
          },
          {
            value: schema.disburse.percent,
            name: schema.disburse.label,
            title: {
              offsetCenter: ['0%', '15%'],
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '40%'],
            },
          },
        ],
        title: {
          fontSize: 14,
        },
        detail: {
          width: 45,
          height: 10,
          fontSize: 14,
          color: 'auto',
          borderColor: 'auto',
          borderRadius: 20,
          borderWidth: 1,
          formatter: '{value}%',
          // padding: [10, 0, 0, 0],
        },
      },
    ],
  }

  return (
    <div>
      <ReactECharts
        option={optionProject}
        // style={{ height: '400px', width: '100%' }}
        className={'react_for_echarts'}
      />

      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12} lg={12} align="right" style={{ color: '#14997a' }}>
            <p>
              <b>{numberThousandSeparator(schema.approve.value) || 0}</b>
            </p>
            <p>{schema.approve.label}</p>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <p>
              <b>{numberThousandSeparator(schema.disburse.value) || 0}</b>
            </p>
            <p>{schema.disburse.label}</p>
          </Col>
        </Row>
      </div>
    </div>
  )
}
